import React from "react";
import { FaBookOpen, FaPaperclip } from "react-icons/fa";
import Button from "../../../components/Button/Button";
import Loader from "../../../components/Loader/Loader";
import { useStudentSession } from "../context/StudentSessionContext";
import useStudentSyllabus from "./hooks/useStudentSyllabus";
import "./StudentSyllabus.css";

// Field names aren't fully confirmed against the real backend contract, so
// every getter here tries a few reasonable variants and falls back quietly
// instead of crashing on a missing/renamed field.
const getSubjectLabel = (item) => {
  if (!item) return "Subject";
  if (typeof item.subject === "string" && item.subject.trim()) return item.subject;
  if (item.subject && typeof item.subject === "object") {
    return item.subject.name || item.subject.title || "Subject";
  }
  return item.subject_name || item.subject_title || "Subject";
};

const getDescription = (item) =>
  item?.description || item?.title || item?.remarks || item?.details || "";

const getAttachmentUrl = (item) =>
  item?.attachment_url ||
  item?.attachment ||
  item?.file_url ||
  item?.file ||
  item?.document_url ||
  item?.document ||
  null;

const StudentSyllabus = () => {
  const { student } = useStudentSession();
  const { syllabusItems, isLoading } = useStudentSyllabus(
    student?.id,
    student?.student_program?.program_id,
    student?.student_program?.session_id
  );

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="student-syllabus">
      {syllabusItems.length === 0 ? (
        <div className="sp-empty-state">
          <span className="sp-icon-tile" data-tone="secondary">
            <FaBookOpen size={18} />
          </span>
          <p className="mb-0">No syllabus available yet</p>
        </div>
      ) : (
        <div className="sp-card-grid">
          {syllabusItems.map((item, index) => {
            const attachmentUrl = getAttachmentUrl(item);
            const description = getDescription(item);
            const subjectLabel = getSubjectLabel(item);
            return (
              <div className="sp-card sp-card--hoverable" key={item?.id || index}>
                <div className="student-syllabus-card-head">
                  <span className="sp-icon-tile">
                    <FaBookOpen />
                  </span>
                  <h3 className="student-syllabus-subject">{subjectLabel}</h3>
                </div>
                {description && <p className="student-syllabus-desc">{description}</p>}
                <Button
                  variant="outline-primary"
                  size="sm"
                  icon={<FaPaperclip />}
                  disabled={!attachmentUrl}
                  onClick={() => attachmentUrl && window.open(attachmentUrl, "_blank", "noopener,noreferrer")}
                >
                  View Attachment
                </Button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default StudentSyllabus;
